"use strict";
var redux_1 = require('redux');
var sequencer_1 = require('./sequencer');
;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = redux_1.combineReducers({
    sequencer: sequencer_1.sequencerReducer,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsc0JBQWdDLE9BQU8sQ0FBQyxDQUFBO0FBQ3hDLDBCQUE2QyxhQUFhLENBQUMsQ0FBQTtBQUkxRCxDQUFDO0FBRUY7a0JBQWUsdUJBQWUsQ0FBWTtJQUN4QyxTQUFTLEVBQUUsNEJBQWdCO0NBQzVCLENBQUMsQ0FBQyJ9


/*****************
 ** WEBPACK FOOTER
 ** ./src/reducers/index.ts
 ** module id = 967
 ** module chunks = 1
 **/